export default [
  {
    key: 'work',
    label: '作業内容',
    style: {
    }
  }, 
   {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/work/listHeader.js